import _ from 'lodash';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const Carousels = dynamic(import('src/components/carousels'));
const Image = dynamic(import('src/components/image'));

const WidgetGallery = ({ data = null, isCate = false, eventDataLayer = {} }: any) => {
  if (_.isEmpty(data?.gallery)) return null;
  const data_gallery = data?.gallery;
  return (
    <>
      <WidgetWrapper
        id='widget-gallery'
        onClick={() =>
          sendDataLayerGlobal({
            ...eventDataLayer,
            data: {
              title: `อัลบั้มรูป : ${data?.title}`,
              heading: 'อัลบั้มรูป',
              index: 1
            }
          })
        }
      >
        <Carousels autoplay={false} slideShow={1} mobileSlideShow={1} pauseOnHover={false} autoplaySpeed={6000} infinite={true}>
          {data_gallery?.map((item: any, index: any) => (
            <div key={index}>
              <Image image={item?.file} title={`อัลบั้มรูป : ${data?.title} รูปที่ ${index + 1}/${data_gallery.length}`} external={false} />
            </div>
          ))}
        </Carousels>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  margin-bottom: 30px;
  .slick-dots {
    position: unset;
    li button {
      height: 15px;
      width: 15px;
      padding: 0px;
    }
  }
`;

export default WidgetGallery;
